import script from "./page-layout.vue?vue&type=script&setup=true&lang=js"
export * from "./page-layout.vue?vue&type=script&setup=true&lang=js"

import "./page-layout.vue?vue&type=style&index=0&id=25f5e598&lang=scss"

const __exports__ = script;

export default __exports__